// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TaEb","questions":"styles_questions__1rylI","footer":"styles_footer__1y8QF"};